import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { SubscriptionPlans } from '@/components/SubscriptionPlans';
import { useSubscription } from '@/hooks/useSubscription';
import NavigationBar from '@/components/NavigationBar';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const Subscription = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkSubscription } = useSubscription();
  const [activating, setActivating] = useState(false);

  useEffect(() => {
    const success = searchParams.get('success');
    const canceled = searchParams.get('canceled');
    const isOnSubscriptionPage = window.location.pathname === '/subscription';

    if ((success === 'true' || canceled === 'true') && isOnSubscriptionPage) {
      if (success === 'true') {
        setActivating(true);
        toast.success('Payment received! Activating your subscription…');
        // Give the Stripe webhook a moment to land before polling
        setTimeout(async () => {
          await checkSubscription();
          setActivating(false);
        }, 1500);
      } else if (canceled === 'true') {
        toast.info('Subscription canceled. You can try again anytime.');
      }

      navigate('/subscription', { replace: true });
    }
  }, [searchParams.get('success'), searchParams.get('canceled'), checkSubscription, navigate]);

  const handleRefreshSubscription = async () => {
    await checkSubscription();
    toast.success('Subscription status updated!');
  };

  return (
    <>
      <NavigationBar />
      <div className="min-h-screen bg-gradient-to-br from-primary/10 via-background to-secondary/10">
        <div className="container mx-auto px-4 py-8">
          {activating && (
            <div className="mb-6 mx-auto max-w-md flex items-center justify-center gap-2 rounded-lg border border-primary/20 bg-primary/5 px-4 py-3 text-sm text-primary">
              <Loader2 className="h-4 w-4 animate-spin" />
              Activating your subscription…
            </div>
          )}
          <div className="text-center mb-8">
            <Button onClick={handleRefreshSubscription} variant="outline" className="mb-4">
              Refresh Subscription Status
            </Button>
            <p className="text-sm text-muted-foreground">
              Click above if your subscription status doesn't appear updated
            </p>
          </div>
          <SubscriptionPlans />
        </div>
      </div>
    </>
  );
};

export default Subscription;